// store/rootReducer.ts
import { combineReducers, type UnknownAction } from '@reduxjs/toolkit';

import registrationReducer from '@/store/slices/registration/registrationSlice'
import authReducer from '@/store/slices/auth/authSlice';
import userReducer from '@/store/slices/user/userSlice';
import SixDetailReducer from '@/store/slices/sixDetail/sixDetailSlice';
import CreateSixReducer from '@/store/slices/createSix/createSixSlice';
import SixCatalogReducer from '@/store/slices/sixCatalog/sixCatalogSlice';
import UIReducer from '@/store/slices/ui/uiSlice';
import ManageAccessReducer from '@/store/slices/manageAccess/manageAccessSlice';
import pocAuthReducer from '@/store/slices/poc/pocAuthSlice';
import connectionReducer from '@/store/slices/poc/connectionSlice';
import messagingReducer from '@/store/slices/poc/messagingSlice';
import heliaReducer from '@/store/slices/poc/heliaSlice';
import cloneQueueReducer from '@/store/slices/poc/cloneQueueSlice';
import fileKeyFacilitationReducer from '@/store/slices/fileKey/fileKeyFacilitationSlice';
import passwordUpdateReducer from '@/store/slices/passwordUpdate/passwordUpdateSlice';
import { logoutThunk } from '@/store/thunks/auth/logoutThunk';

const appReducer = combineReducers({
  registration: registrationReducer,
  auth: authReducer,
  user: userReducer,
  sixDetail: SixDetailReducer,
  createSix: CreateSixReducer,
  sixCatalog: SixCatalogReducer,
  ui: UIReducer,
  manageAccess: ManageAccessReducer,
  pocAuth: pocAuthReducer,
  connection: connectionReducer,
  messaging: messagingReducer,
  helia: heliaReducer,
  cloneQueue: cloneQueueReducer,
  fileKeyFacilitation: fileKeyFacilitationReducer,
  passwordUpdate: passwordUpdateReducer,
  // Add other reducers here as your app grows
});

export const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: UnknownAction
) => {
  if (action.type === logoutThunk.fulfilled.type) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

// Infer the `RootState` type from the root reducer
export type RootState = ReturnType<typeof appReducer>;
